<button
  class="btn btn-default btn-white btn-sm btn-reaction mx-2 mx-sm-4 mx-md-2 mx-lg-4"
  [class.btn-reaction-active]="value"
  data-cy="add-emoji-reaction"
  cdkOverlayOrigin #trigger="cdkOverlayOrigin"
  (mouseenter)="buttonHovered.next(true)"
  (mouseleave)="buttonHovered.next(false)"
  (click)="react($safeNavigationMigration(value?.id))">
  @if (!value) {
  <i class="fa-regular fa-sharp fa-regular fa-face-smile-plus"></i> {{
  'comment-card.react' | translate }}
  } @else {
  <span class="fs-5 pe-2">{{ value.smiley }}</span>
  {{value.label | translate}}
  }
</button>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayPositions]="overlayPositions"
  [cdkConnectedOverlayOpen]="isOpened$ | async">
  <div
    class="d-flex bg-white border emoji-reactions"
    (mouseenter)="overlayHovered.next(true)"
    (mouseleave)="overlayHovered.next(false)">
    @for (reaction of options; track $index) {
      @if (reaction.smiley) {
      <button
        (click)="react(reaction.id)"
        class="btn btn-default btn-white btn-sm fs-3"
        [ngClass]="{'border-start ms-1 ps-2 pe-1': reaction.id === 'agree', 'selected': reaction.id === value?.id}"
        [matTooltip]="reaction.label | translate"
        matTooltipPosition="above">
        <span>{{reaction.smiley}}</span>
      </button>
      }
    }
  </div>
</ng-template>